import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import mapGermany from "../../public/map-germany.json";
import { registerMap } from "echarts";
import { useRouter } from "vue-router/composables";
import { useBreakpointsStore } from "@/stores/breakpoints";

interface FromActionPayload {
  dataIndexInside: number;
}

interface EchartEvent {
  type: string;
  fromActionPayload: FromActionPayload | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GermanMapChart',
  setup(__props) {

const breakpointStore = useBreakpointsStore();

registerMap("germany", mapGermany as any);

const router = useRouter();

const cities = [
  { name: "Bremen", value: [8.832410649314353, 53.08573257089985] },
  { name: "Celle", value: [10.094798685402601, 52.62978647785799] },
  { name: "Dresden", value: [13.73962526470231, 51.04876305522623] },
  { name: "Düren", value: [6.470955431459726, 50.80166685114307] },
  { name: "Esslingen", value: [9.438475555787381, 48.61013] },
  { name: "Herten", value: [7.14009905197711, 51.60051361600348] },
  { name: "Husum", value: [9.05265464628601, 54.485061686092344] },
  { name: "Leipzig", value: [12.39568911910943, 51.3249676567771] },
  { name: "Neubrandenburg", value: [13.295876198173211, 53.555556506771985] },
  { name: "Neuruppin", value: [12.83233844927547, 52.919421937983934] },
  { name: "Offenburg", value: [7.935780805364736, 48.3167024506766] },
  { name: "Plauen", value: [12.142594018692915, 50.49292553652569] },
  { name: "Rendsburg", value: [9.673812615622557, 54.24674257047891] },
  { name: "Stuttgart", value: [9.171720523658701, 48.8715166064113] },
  {
    name: "Weilheim",
    value: [11.147751515939664, 47.84517970389295],
  },
  { name: "Wismar", value: [11.457846969122565, 53.891315258986495] },
];

const link = (event: EchartEvent) => {
  if (event.type === "selectchanged" && event.fromActionPayload) {
    router.push({
      name: "LocalAnalysis",
      query: {
        stadt: encodeURIComponent(
          cities[event.fromActionPayload.dataIndexInside].name === "Düren"
            ? "Dueren"
            : cities[event.fromActionPayload.dataIndexInside].name
        ),
      },
    });
  } else {
    router.push({ name: "NationalAnalysis" });
  }
};

const option = computed(() => {
  return {
    backgroundColor: "transparent",
    title: {
      show: true,
      text: "",
    },
    tooltip: {
      show: true,
      backgroundColor: "rgba(0,0,0,0.7)",
      textStyle: {
        color: "white",
      },
    },
    geo: [
      {
        nameProperty: "iso-a2",
        type: "map",
        map: "germany",
        itemStyle: {
          areaColor: "#F3F6F7",
          borderColor: "#989898",
        },
        emphasis: {
          itemStyle: {
            areaColor: "#729EA1",
            borderColor: "#729EA1",
            borderWidth: 1,
          },
          scale: true,
          focus: "self",
        },
        tooltip: {
          formatter: "Zur bundesweiten Analyse",
        },
        selectedMode: false,
        data: [],
      },
    ],
    series: [
      {
        name: "cities",
        type: "scatter",
        coordinateSystem: "geo",
        data: cities,
        symbolSize: 20,
        symbol: "pin",
        encode: {
          value: 2,
        },
        itemStyle: {
          color: "#35415A",
        },
        label: {
          formatter: "{b}",
          position: "right",
          show: !breakpointStore.isSmallDevice,
          distance: 7,
          fontFamily: "Karla",
          fontWeight: 700,
          fontSize: breakpointStore.width < 800 ? 11 : 13,
          textBorderWidth: 0,
        },
        emphasis: {
          disable: true,
        },
        blur: {
          label: {
            show: false,
          },
          itemStyle: {
            opacity: 0.5,
          },
        },
        tooltip: {
          formatter: "Analyse von {b}",
          position: "bottom",
        },
      },
      {
        name: "invisibleCitySelectionCircles",
        type: "scatter",
        coordinateSystem: "geo",
        data: cities,
        symbolSize: 75,
        encode: {
          value: 2,
        },
        itemStyle: {
          color: "transparent",
        },
        label: {
          formatter: "{b}",
          position: "right",
          show: false,
          distance: 7,
          fontFamily: "Karla",
          fontWeight: 700,
          fontSize: breakpointStore.width < 800 ? 14 : 15,
          textBorderWidth: 0,
        },
        emphasis: {
          focus: "self",
          scale: 0.75,
          itemStyle: {
            color: "#729EA1",
            opacity: 0.8,
          },
          label: {
            show: true,
          },
        },
        tooltip: {
          formatter: "Analyse von {b}",
          position: "bottom",
        },
      },
    ],
  };
});

return { __sfc: true,breakpointStore, router, cities, link, option }
}

})